import { useGetConsultantOpportunityStatsByTeamQuery } from "@bonliva-crm/graphql";
import { StatsRow } from "./stats-row";

type Props = {
  team: string;
  start: Date;
  end: Date;
};

export function TeamStats(props: Props) {
  const userStats = useGetConsultantOpportunityStatsByTeamQuery({
    variables: {
      team: props.team,
      start: props.start,
      end: props.end
    },
    fetchPolicy: "network-only"
  });

  return (
    <StatsRow
      title={props.team + " Team"}
      loading={userStats.loading}
      data={userStats.data?.consultantOpportunityStatsByTeam}
    />
  );
}
